export default __webpack_public_path__ + "static/media/NovoNordiskBlueLogo.0af95b57.webp";